__turbopack_context__.v({
  "chevron": "PlasmicFaqItem-module__B6sHOq__chevron",
  "chevronopen": "PlasmicFaqItem-module__B6sHOq__chevronopen",
  "freeBox__bZfRd": "PlasmicFaqItem-module__B6sHOq__freeBox__bZfRd",
  "freeBox__jEwH8": "PlasmicFaqItem-module__B6sHOq__freeBox__jEwH8",
  "freeBox__jcBXn": "PlasmicFaqItem-module__B6sHOq__freeBox__jcBXn",
  "freeBox__whosm": "PlasmicFaqItem-module__B6sHOq__freeBox__whosm",
  "freeBox__yminF": "PlasmicFaqItem-module__B6sHOq__freeBox__yminF",
  "freeBoxopen__yminF9Er1E": "PlasmicFaqItem-module__B6sHOq__freeBoxopen__yminF9Er1E",
  "h1": "PlasmicFaqItem-module__B6sHOq__h1",
  "root": "PlasmicFaqItem-module__B6sHOq__root",
  "slotTargetChildren": "PlasmicFaqItem-module__B6sHOq__slotTargetChildren",
  "slotTargetSlot": "PlasmicFaqItem-module__B6sHOq__slotTargetSlot",
});
